module.exports = __webpack_public_path__ + "img/MK_Label.cb7cc20f.png";